import axios from "./axios";

export const dashboardReq = (user) => {
  const payload = { user };
  return axios.post("/dashboard", payload); // ✅ orden correcto
};

export const BillingData = () => {
  return axios.get("/getbillingdata");
};

export const makePayment = (body) => {
  return axios.post("/makePayment", body);
};

export const deleteReservation = (body) => {
  return axios.post("/deleteReservation", body);
};

export const markAs = (body) => {
  return axios.post("/markAs", body);
};

export const payInvoice = (body) => {
  console.log("📡 Enviando datos al backend:", body);

  return axios.post("/payInvoice", body, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Función para realizar una solicitud POST al endpoint de reservas
export const getReserves = (body) => axios.post("/getAvailability", body);
export const ReservationFormAxios = (body) =>
  axios.post("/manualreserve", body);
export const manualPay = (body) => axios.post("/manualPay", body);
export const suscribe = (body) => axios.post("/suscribepush", body);
export const editReserve = (body) => axios.post("/editReserve", body);
export const ubikaLead = (body) => axios.post("/ubikalead", body);

export const fetchPrices = async (body) => {
  const res = await axios.post("/config", body);
  return res.data; // { success, data }
};

export const savePrices = async (body) => {
  const res = await axios.post("/setPrices", body);
  return res.data; // { success, result }
};

/* =========================================================================
 * IMÁGENES POR HABITACIÓN (unitId OPCIONAL)
 * Backend: /dashboard/rooms/:roomId/images?unitId=...
 * - Para no romper: si no pasás unitId, funciona como antes.
 * ========================================================================= */

export async function fetchRoomImages(roomId, unitId) {
  const { data } = await axios.get(`/dashboard/rooms/${roomId}/images`, {
    withCredentials: true,
    // ✅ si unitId viene, lo mandamos; si no, no agregamos params
    params: unitId != null ? { unitId } : undefined,
  });
  return data; // { success: true, images: [...] }
}

export async function uploadRoomImage(roomId, unitId, formData) {
  const { data } = await axios.post(
    `/dashboard/rooms/${roomId}/images`,
    formData,
    {
      withCredentials: true,
      headers: { "Content-Type": "multipart/form-data" },
      // ✅ unitId opcional por query param
      params: unitId != null ? { unitId } : undefined,
    },
  );
  return data;
}

export async function deleteRoomImage(roomId, unitId, imageId) {
  const encodedId = encodeURIComponent(imageId);

  const resp = await axios.delete(
    `/dashboard/rooms/${roomId}/images/${encodedId}`,
    {
      withCredentials: true,
      // ✅ unitId opcional por query param
      params: unitId != null ? { unitId } : undefined,
    },
  );

  return resp.data;
}

/* =========================================================================
 * AMENITIES POR HABITACIÓN (unitId OPCIONAL)
 * Backend: /dashboard/rooms/:roomId/amenities?unitId=...
 * - Para no romper: si no pasás unitId, funciona como antes (fallback server).
 * ========================================================================= */

export async function fetchRoomAmenities(roomId, unitId) {
  const resp = await axios.get(`/dashboard/rooms/${roomId}/amenities`, {
    withCredentials: true,
    // ✅ unitId opcional por query param
    params: unitId != null ? { unitId } : undefined,
  });
  return resp.data; // { success, amenities, roomId, unitId, usedFallback }
}

export async function saveRoomAmenities(roomId, unitId, amenities) {
  // ✅ compat: permitir firma vieja saveRoomAmenities(roomId, amenities)
  let realUnitId = unitId;
  let realAmenities = amenities;

  if (Array.isArray(unitId) && amenities === undefined) {
    // llamado viejo: (roomId, amenities)
    realAmenities = unitId;
    realUnitId = undefined;
  }

  const resp = await axios.post(
    `/dashboard/rooms/${roomId}/amenities`,
    { amenities: realAmenities }, // array de strings
    {
      withCredentials: true,
      // ✅ unitId opcional por query param
      params: realUnitId != null ? { unitId: realUnitId } : undefined,
    },
  );
  return resp.data; // { success, amenities, roomId, unitId, usedFallback }
}

/* =========================================================================
 * MONEDA FACTURACIÓN (sin cambios)
 * ========================================================================= */

export async function fetchBillingCurrency() {
  const resp = await axios.get("/dashboard/billing-currency", {
    withCredentials: true,
  });
  return resp.data; // { success, currency }
}

export async function saveBillingCurrency(currency) {
  const resp = await axios.post(
    "/dashboard/billing-currency",
    { currency }, // "ARS" | "CLP"
    { withCredentials: true },
  );
  return resp.data; // { success, currency }
}
